import { motion } from "framer-motion";
import { useContent } from "@/context/ContentContext";
import { Kicker, Reveal } from "./Reveal";
import SplitText from "./motion/SplitText";
import Button from "./Button";

const CARDS = [
  ["educators", "educators_title", "educators_text", "/membership", "Become a member", "gold"],
  ["partners", "partners_title", "partners_text", "/contact", "Work with us", "outlineLight"],
];

export default function JoinCta() {
  const c = useContent();
  return (
    <section className="relative overflow-hidden bg-pine text-white" data-testid="join-cta-section">
      <motion.img
        src="/brand/leaf.png"
        alt=""
        aria-hidden
        className="pointer-events-none absolute -right-20 -top-16 h-[420px] w-[420px] object-contain opacity-[0.12] md:h-[600px] md:w-[600px]"
        initial={{ rotate: -8, y: 60 }}
        whileInView={{ rotate: 0, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
      />
      <div className="relative mx-auto max-w-[1200px] px-5 py-20 md:py-28">
        <Reveal>
          <Kicker light>{c.get("join", "kicker")}</Kicker>
        </Reveal>
        <SplitText
          as="h2"
          inView
          text={c.get("join", "title")}
          className="mt-4 max-w-4xl font-display text-3xl font-semibold leading-[1.15] !text-white md:text-[2.6rem]"
          data-testid="join-title"
        />
        <Reveal delay={0.3}>
          <p className="mt-4 font-display text-xl font-medium text-mintlight md:text-2xl">
            {c.get("join", "subtitle")}
          </p>
        </Reveal>

        <div className="mt-12 grid gap-6 md:grid-cols-2">
          {CARDS.map(([id, titleKey, textKey, to, cta, variant], i) => (
            <Reveal
              key={id}
              delay={i * 0.15}
              className="group rounded-[10px] border border-white/15 bg-white/[0.06] p-8 backdrop-blur-sm transition-[background-color,transform] duration-500 hover:-translate-y-1 hover:bg-white/10 md:p-10"
              data-testid={`join-${id}-card`}
            >
              <p className="font-display text-xs font-semibold uppercase tracking-[0.16em] text-terra">0{i + 1}</p>
              <h3 className="mt-4 font-display text-2xl font-semibold !text-white md:text-3xl">
                {c.get("join", titleKey)}
              </h3>
              <p className="mt-3 max-w-md leading-relaxed text-[#CFE3D9]">{c.get("join", textKey)}</p>
              <div className="mt-8">
                <Button to={to} variant={variant} arrow="up" data-testid={`join-${id}-button`}>
                  {cta}
                </Button>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
